import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/imgs/lineqr.png'
import _imports_1 from '../assets/imgs/logo.svg'


const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = { class: "flex footer__left" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "footer__qr"
}, null, -1)
const _hoisted_6 = { class: "footer__address" }
const _hoisted_7 = { class: "flex footer__menu" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("a", {
            href: _ctx.text.addlinelink,
            class: "footer__qrlink",
            innerHTML: _ctx.text.addline,
            target: "_blank"
          }, null, 8, ["href", "innerHTML"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("a", {
            href: 'tel:' + _ctx.text.tel,
            class: "footer__tel",
            innerHTML: _ctx.text.tel
          }, null, 8, ["href", "innerHTML"]),
          _createVNode("div", {
            innerHTML: _ctx.text.address
          }, null, 8, ["innerHTML"])
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
          return (_openBlock(), _createBlock("a", {
            class: "menu",
            key: menu.id,
            href: 
            _ctx.isExternal(menu.to) || menu.to == '/login' || menu.to == '/agent'
              ? menu.to
              : `#${menu.to}`
          ,
            innerHTML: menu.title
          }, null, 8, ["href", "innerHTML"]))
        }), 128))
      ]),
      _createVNode("div", {
        class: "footer__logo",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.linktohome()))
      }, [
        _hoisted_8
      ])
    ])
  ]))
}